import { NavLink, useLocation } from "react-router-dom";
import classNames from "classnames";

const ActiveLink = ({ children, className, onLinkClick, ...props }) => {
  const location = useLocation();
  const isActive = location.pathname.split("/")[1] === props.to.split("/")[1];
  return (
    <NavLink
      {...props}
      className={classNames(className, { "active-link": isActive })}
      onClick={onLinkClick} // Call the passed function on click
    >
      {children}
    </NavLink>
  );
};

export default ActiveLink;
